import actions from './actions';

const initialState = {
  textLogin: 'Bem vindo',
  theme: {
    // 'secondary-color': '#00f',
  },
};
const { CONFIG_DATA_SUCCESS, CONFIG_DATA_BEGIN, CONFIG_DATA_ERR } = actions;

const ConfigReducers = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CONFIG_DATA_BEGIN:
      return {
        ...state,
        sLoading: true,
      };
    case CONFIG_DATA_SUCCESS:
      return {
        ...state,
        ...data,
        sLoading: false,
      };
    case CONFIG_DATA_ERR:
      return {
        ...state,
        error: err,
        sLoading: false,
      };
    default:
      return state;
  }
};

export default ConfigReducers;
